'use client'

import { Page, Text, View, Document, StyleSheet, PDFViewer, Svg, Line} from '@react-pdf/renderer';

import React, { useMemo, useRef, useEffect, useState} from 'react';

import {useLocation, useParams, useSearchParams} from 'react-router-dom';

import { createStore, Worker,Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin, ToolbarProps, ToolbarSlot } from '@react-pdf-viewer/default-layout';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import '@react-pdf-viewer/full-screen/lib/styles/index.css';

import {ExitFullScreenIcon, FullScreenIcon, fullScreenPlugin, Zoom} from '@react-pdf-viewer/full-screen';
// Import the styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import {Header as Nav} from "../header/Header";
import {
    Box,
    Container,
    Flex,
    useColorModeValue,
    Heading,
    Button,
    chakra,
    Stack,
    Card,
    Image,
    useToast,
    Menu,
    MenuItem,
    MenuButton,
    MenuList,
    IconButton
} from "@chakra-ui/react";

import {ChevronDownIcon, DeleteIcon } from "@chakra-ui/icons";

import '../../styles/pdf-viewer-styles.css';
import {useEvoContext} from "../../context/evo.context";
import Cookies from "js-cookie";
import PublicIssuesDataProvider from "../dataProviderEvo/public-issues-data-provider";
import IssueDetailDataProvider from "../dataProviderEvo/issue-detail-data-provider";
import IssuePublicDetailDataProvider from "../dataProviderEvo/issue-public-detail-data-provider";
import {ROUTE_MAIN, ROUTE_PARAM_ISSUE, ROUTE_PURCHASE} from "../../App";
import BookmarkAddDataProvider from "../dataProviderEvo/bookmark-add-data-provider";
import IssueBookmarksDataProvider from "../dataProviderEvo/issue-bookmarks-data-provider"; // Import your custom CSS
import { pageNavigationPlugin } from "@react-pdf-viewer/page-navigation";
import BookmarkDeleteDataProvider from "../dataProviderEvo/bookmark-delete-data-provider";

import { FaArrowLeft, FaSearchMinus, FaSearchPlus, FaExpand, FaChevronLeft, FaChevronRight, FaBookmark, FaList} from 'react-icons/fa';

import { isMobile } from 'react-device-detect';
import {isNotEmptyObj} from "../../infrastructure/utils/formUtils";

// Create styles
const styles = StyleSheet.create({
    page: {
        flexDirection: 'row',
        backgroundColor: '#E4E4E4'
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1
    }
});

// const MyDocument = () => (
//     <Document>
//         <Page wrap={false}>
//             <Logo />
//         </Page>
//     </Document>
// );

export default function Read({publicIssue = false}) {

    const { id_issue: issue, page} = useParams();

    const location = useLocation(); // Get the current location
    const {isLoggedIn, navHistory, hasSubscriptionActive, authToken, userId, loading, userData} = useEvoContext();
    const [currentPage, setCurrentPage] = useState(1);
    const [bookmarks, setBookmarks] = useState({});
    const [refreshBookmarks, setRefreshBookmarks] = useState(false);
    const [isDocumentLoaded, setIsDocumentLoaded] = useState(false);
    const [defaultPage, setDefaultPage] = useState(0);

    const toast = useToast();

    const pageNavigationPluginInstance = pageNavigationPlugin(); // Initialize plugin
    const { jumpToPage } = pageNavigationPluginInstance;

    // // Load the saved page from localStorage when the component mounts
    // useEffect(() => {
    //     const savedPage = localStorage.getItem('currentPage');
    //     if (savedPage) {
    //         setCurrentPage(parseInt(savedPage, 10));
    //     }
    // }, []);

    // Update the current page state as the user navigates
    const handlePageChange = (e) => {
        const newPage = e.currentPage + 1; // currentPage is zero-indexed
        setCurrentPage(newPage);
    };

    const addBookmark = () => {
        let dp  = new BookmarkAddDataProvider();
        dp.addBookMark(userId, issue, currentPage, authToken).then((res) => {
            if (res.status === 'OK') {
                setRefreshBookmarks(true);
                toast({
                    description: "Záložka byla úspěšně přidána.",
                    status: 'success',
                    duration: 5000,
                    isClosable: true,
                    position: "top"
                });
            }

            else {
                toast({
                    description: res.errors[0] || 'Zkuste akci zopakovat.',
                    status: 'error',
                    duration: 5000,
                    isClosable: true,
                    position: "top"
                });
            }

        });
    };

    // const savePageToLocalStorage = () => {
    //     localStorage.setItem('currentPage', currentPage);
    //
    //     // console.log('a');
    //     // alert(`Page ${currentPage} saved to local storage!`);
    // };


     let backTo = (navHistory[navHistory.length - 2] != undefined && location.pathname != navHistory[navHistory.length - 2]) ? navHistory[navHistory.length - 2] : '/';

    const renderToolbar = (Toolbar: (props: ToolbarProps) => ReactElement) => (
        <Toolbar>
            {(slots: ToolbarSlot) => {
                const {
                    CurrentPageInput,
                    CurrentScale,
                    GoToNextPage,
                    GoToPreviousPage,
                    NumberOfPages,
                    ZoomIn,
                    ZoomOut,
                    EnterFullScreen
                } = slots;
                return (
                    <div
                        style={{
                            alignItems: 'center',
                            display: 'flex',
                        }}
                    >
                        <div style={{ padding: '0px 2px', position: "absolute", left: 0 }}>
                            <Button
                                as={"a"}
                                style={{
                                    backgroundColor: 'transparent',
                                    border: '1px white solid',
                                    borderRadius: '4px',
                                    color: '#ffffff',
                                    cursor: 'pointer',
                                    padding: '8px',
                                }}
                                href={backTo}
                            >
                                {isMobile ? <FaArrowLeft /> : 'Zpět'}
                            </Button>
                        </div>
                        <div style={{ padding: '0px 2px' }}>
                            <ZoomOut>
                                {(props) => (
                                    <button
                                        style={{
                                            backgroundColor: 'transparent',
                                            border: '1px white solid',
                                            borderRadius: '4px',
                                            color: '#ffffff',
                                            cursor: 'pointer',
                                            padding: '8px',
                                        }}
                                        onClick={props.onClick}
                                    >
                                        {isMobile ? <FaSearchMinus /> : 'Oddálit'}
                                    </button>
                                )}
                            </ZoomOut>
                        </div>
                        {!isMobile && (
                            <div style={{ padding: '0px 2px' }}>
                                <CurrentScale>{(props) => <span>{`${Math.round(props.scale * 100)}%`}</span>}</CurrentScale>
                            </div>
                        )}
                        <div style={{ padding: '0px 2px' }}>
                            <ZoomIn>
                                {(props) => (
                                    <button
                                        style={{
                                            backgroundColor: 'transparent',
                                            border: '1px white solid',
                                            borderRadius: '4px',
                                            color: '#ffffff',
                                            cursor: 'pointer',
                                            padding: '8px',
                                        }}
                                        onClick={props.onClick}
                                    >
                                        {isMobile ? <FaSearchPlus /> : 'Přiblížit'}
                                    </button>
                                )}
                            </ZoomIn>
                        </div>
                        {!isMobile && (<div style={{ padding: '0px 2px' }}>
                            <EnterFullScreen>
                                {(props) => (
                                    <button
                                        style={{
                                            backgroundColor: 'transparent',
                                            border: '1px white solid',
                                            borderRadius: '4px',
                                            color: '#ffffff',
                                            cursor: 'pointer',
                                            padding: '8px',
                                        }}
                                        onClick={props.onClick}
                                    >
                                        {isMobile ? <FaExpand /> : 'Celá obrazovka'}
                                    </button>
                                )}
                            </EnterFullScreen>
                        </div>)}
                        <div style={{ padding: '0px 2px', marginLeft: 'auto' }}>
                            <GoToPreviousPage>
                                {(props) => (
                                    <button
                                        style={{
                                            backgroundColor: props.isDisabled ? '#A0AEC0' : 'transparent',
                                            border: '1px white solid',
                                            borderRadius: '4px',
                                            color: '#ffffff',
                                            cursor: props.isDisabled ? 'not-allowed' : 'pointer',
                                            padding: '8px',
                                        }}
                                        disabled={props.isDisabled}
                                        onClick={props.onClick}
                                    >
                                        {isMobile ? <FaChevronLeft /> : 'Předchozí'}
                                    </button>
                                )}
                            </GoToPreviousPage>
                        </div>
                        <div style={{ padding: '0px 2px', width: '2rem' }}>
                            <CurrentPageInput />
                        </div>
                        {!isMobile && (
                            <div style={{ padding: '0px 2px' }}>
                                / <NumberOfPages />
                            </div>
                        )}
                        <div style={{ padding: '0px 2px' }}>
                            <GoToNextPage>
                                {(props) => (
                                    <button
                                        style={{
                                            backgroundColor: props.isDisabled ? '#A0AEC0' : 'transparent',
                                            border: '1px white solid',
                                            borderRadius: '4px',
                                            color: '#ffffff',
                                            cursor: props.isDisabled ? 'not-allowed' : 'pointer',
                                            padding: '8px',
                                        }}
                                        disabled={props.isDisabled}
                                        onClick={props.onClick}
                                    >
                                        {isMobile ? <FaChevronRight /> : 'Následující'}
                                    </button>
                                )}
                            </GoToNextPage>
                        </div>
                        {isLoggedIn && (
                            <div style={{ padding: '0px 2px' }}>
                                <Button
                                    style={{
                                        backgroundColor: 'transparent',
                                        border: '1px white solid',
                                        borderRadius: '4px',
                                        color: '#ffffff',
                                        cursor: 'pointer',
                                        padding: '8px',
                                    }}
                                    onClick={addBookmark}
                                >
                                    {isMobile ? <FaBookmark /> : 'Přidat záložku'}
                                </Button>
                            </div>
                        )}
                        {isLoggedIn && Object.keys(bookmarks).length > 0 && isDocumentLoaded && (
                            <BookmarksDropdown bookmarks={bookmarks} setBookmarks={setBookmarks} setCurrentPage={setCurrentPage} jumpToPage={jumpToPage} />
                        )}
                    </div>
                );
            }}
        </Toolbar>
    );


    const renderLoader = () => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
             <p>{"Načítá se..."}</p>
        </div>
    );


    const defaultLayoutPluginInstance = defaultLayoutPlugin({
        renderToolbar,
        sidebarTabs: (defaultTabs) => {
            return defaultTabs.filter(
                (tab) => tab.title === 'Thumbnail'
            );
        },
    });

    const fullScreenPluginInstance = fullScreenPlugin({
        onEnterFullScreen: () => {
            const pdfContainer = document.querySelector('.rpv-core__viewer');
            if (pdfContainer) {
                pdfContainer.classList.add('fullscreen-mode');
            }
        },
        onExitFullScreen: () => {
            const pdfContainer = document.querySelector('.rpv-core__viewer');
            if (pdfContainer) {
                pdfContainer.classList.remove('fullscreen-mode');
            }
        },
    });

    const [issueData, setIssueData] = useState([]);
    const [issueSrc, setIssueSrc] = useState('');

    // const [searchParams] = useSearchParams();
    // const issue = searchParams.get(ROUTE_PARAM_ISSUE); // Access query parameter 'name'


    useEffect(() => {
        if(defaultPage == 0){
            setDefaultPage(page);
        } else if(defaultPage > 0){
            setCurrentPage(defaultPage);
            jumpToPage(defaultPage - 1)
        }
    }, [isDocumentLoaded]);


    useEffect(() => {

        if(!issueSrc && !loading){

            if(!isLoggedIn || (!hasSubscriptionActive && Object.keys(userData).length > 0)){
                let dp  = new IssuePublicDetailDataProvider();
                dp.getData(issue, {}).then((res) => {

                    /* ERROR je temp*/
                    if (res && (res.status === 'OK' || res.status === 'ERROR')) {
                        setIssueSrc(res.data.pdf);
                        setIssueData(res.data);
                    }

                    else {
                        // toast({
                        //     title: 'Placeni se nezdařilo',
                        //     description: res.errors[0] || 'Zkuste akci zopakovat.',
                        //     status: 'error',
                        //     duration: 5000,
                        //     isClosable: true,
                        // });
                    }

                });
            }
        }

    }, [issueSrc, loading, userData]);

    useEffect(() => {
        if(!issueSrc && !loading && Object.keys(userData).length > 0){
           if(isLoggedIn && hasSubscriptionActive)  {
                let headers = {
                    // "Auth-login-name": formData.email,
                    // "Auth-login-password-b64": btoa(formData.password),
                    "Auth-token": authToken
                }


                let dp  = new IssueDetailDataProvider();
                dp.getData(issue, {}, headers).then((res) => {

                    if (res.status === 'OK') {

                        const base64 = res.data.pdf;
                        const binaryString = atob(base64);

                        const binaryData = new Uint8Array(binaryString.length);
                        for (let i = 0; i < binaryString.length; i++) {
                            binaryData[i] = binaryString.charCodeAt(i);
                        }

                        setIssueSrc(binaryData);
                        // setIssueSrc(res.data.pdf);
                        setIssueData(res.data);
                    }

                    else {
                        // toast({
                        //     title: 'Placeni se nezdařilo',
                        //     description: res.errors[0] || 'Zkuste akci zopakovat.',
                        //     status: 'error',
                        //     duration: 5000,
                        //     isClosable: true,
                        // });
                    }
                });
            }
        }

    }, [authToken, isLoggedIn, loading, userData]);

    useEffect(() => {

        if(isLoggedIn && issue && (Object.keys(bookmarks).length  == 0 || refreshBookmarks)){

                let dp  = new IssueBookmarksDataProvider();
                dp.getData(userId, issue, authToken).then((res) => {

                    if(refreshBookmarks){
                        setRefreshBookmarks(false);
                    }

                    if (res.status === 'OK') {
                        if(isNotEmptyObj(res.data)){
                            setBookmarks(res.data);
                        }

                    }

                    else {
                        toast({
                            description: res.errors[0],
                            status: 'error',
                            duration: 5000,
                            isClosable: true,
                            position: "top"
                        });
                    }
                });
        }

    }, [bookmarks, refreshBookmarks]);




    const [numPages, setNumPages] = useState(0);

    // const handleDocumentLoad = (doc) => {
    //     console.log(`PDF loaded with ${doc.numPages} pages`);
    //     setNumPages(doc.numPages);
    //     setIsDocumentLoaded(true);
    // };

    return (
        <>

            <Box pb={"150px"} height="100vh" bgGradient="linear(to-b, black, gray.600, gray.500, gray.400)">
                {issueSrc && ( <Container maxW={'8xl'} py={5}>
                <Box /*bg={useColorModeValue('#f9f9f9', '#1a202c')}*/ px={4}>
                    <Flex h={window.innerHeight - 100} alignItems={'center'} justifyContent={'space-between'}>
                        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                            <Viewer fileUrl={issueSrc} plugins={[defaultLayoutPluginInstance, fullScreenPluginInstance, pageNavigationPluginInstance]}

                                    // initialPage={currentPage - 1} // initialPage is zero-indexed
                                    initialPage={isDocumentLoaded ? currentPage - 1 : 0}
                                    onPageChange={handlePageChange}
                                    renderLoader={renderLoader}
                                    // onDocumentLoad={() => setIsDocumentLoaded(true)}
                                    // onDocumentLoad={handleDocumentLoad}
                                    onDocumentLoad={({ doc }) => {
                                        setNumPages(doc.numPages);
                                        setIsDocumentLoaded(true);

                                        /*console.log(`PDF loaded with ${doc.numPages} pages`);
                                        if (currentPage - 1 >= doc.numPages) {
                                            console.warn("Initial page index is out of bounds");
                                        }*/
                                    }}
                                    // onLoadSuccess={(pdf) => {
                                    //     setIsDocumentLoaded(true);
                                    // }}
                                    renderPage={(props) => (
                                        <div>
                                            {/* Render the actual PDF page */}
                                            {props.canvasLayer.children}
                                            {props.annotationLayer.children}
                                            {props.textLayer.children}
                                            {/* Add custom content between pages */}
                                            {/*{props.pageIndex < props.doc.numPages - 1 && (*/}
                                            {!isLoggedIn/*!hasSubscription*/ && props.pageIndex === (issueData.publicCount - 1) && (
                                                <Box
                                                    p={{ base: 4, md: 6 }} // Adjust padding for mobile and desktop
                                                    mt={4}
                                                    mb={4}
                                                    borderRadius="md"
                                                    textAlign="center"
                                                    display="flex"
                                                    flexDirection="column"
                                                    justifyContent="flex-end" // Keep content at the bottom
                                                    alignItems="center" // Center content horizontally
                                                    boxShadow="md"
                                                    position="absolute"
                                                    top={0}
                                                    left={0}
                                                    w="100%"
                                                    h={{ base: "auto", xl: "100%" }}
                                                    zIndex={9}
                                                    bg={{
                                                        base: "linear-gradient(to bottom, rgba(255,255,255,0.9), white)",
                                                        md: "linear-gradient(to bottom, rgba(255,255,255,0.1), white)"
                                                    }} // Responsive background
                                                >
                                                    <Box mb={3} textAlign="center" py={2}> {/* Reduced margin between rows */}
                                                        <Box
                                                            fontSize={{ base: "md", lg: "2xl" }} // Adjusted font size for desktop
                                                            as="div"
                                                            fontWeight="bold"
                                                            textAlign="center"
                                                        >
                                                            Zaujal Vás obsah?
                                                        </Box>
                                                        <Box fontSize={{ base: "xs", md: "md" }} as="div" py={1}>
                                                            Prozkoumejte celé vydání tohoto čísla a ponořte se do ještě více zajímavých článků a novinek ze světa vína.
                                                        </Box>
                                                        <Box fontSize={{ base: "xs", md: "md" }} as="div" py={1}>
                                                            Kliknutím na tlačítko níže si můžete zakoupit předplatné a získat přístup k celému archivu vinařského obzoru od roku 2014.
                                                        </Box>
                                                        <Box fontSize={{ base: "xs", md: "md" }} as="div" py={1}>
                                                            Nechte se inspirovat a rozšiřte své obzory!
                                                        </Box>
                                                    </Box>

                                                    <Box py={{ base: 1, md: 2 }} textAlign="center"> {/* Responsive spacing */}
                                                        <Button
                                                            as="a"
                                                            href={ROUTE_MAIN + ROUTE_PURCHASE}
                                                            colorScheme="pink"
                                                            size={{ base: "sm", md: "md" }} // Made button smaller
                                                            borderRadius="full"
                                                        >
                                                            Zakoupit předplatné
                                                        </Button>
                                                    </Box>
                                                </Box>
                                            )}
                                        </div>
                                    )}
                            />
                        </Worker>
                    </Flex>
                </Box>
            </Container>)}
        </Box>
        </>
    );

}

/**
 *
 * @param bookmarks
 * @param setBookmarks
 * @param setCurrentPage
 * @param jumpToPage
 * @returns {JSX.Element}
 * @constructor
 */
const BookmarksDropdown = ({bookmarks, setBookmarks, setCurrentPage, jumpToPage }) => {

    const {authToken, userId} = useEvoContext();
    const toast = useToast();

    const handleRemove = (bookmarkId) => {

        let dp  = new BookmarkDeleteDataProvider();
        dp.deleteBookmark(userId, bookmarkId, authToken).then((res) => {

            if (res.status === 'OK') {

                const updatedData = { ...bookmarks };
                delete updatedData[bookmarkId];
                setBookmarks(updatedData);

                toast({
                    description: "Záložka byla úspěšně odstraněna",
                    status: 'success',
                    duration: 5000,
                    isClosable: true,
                    position: "top"
                });
            }

            else {
                toast({
                    description: res.errors[0],
                    status: 'error',
                    duration: 5000,
                    isClosable: true,
                    position: "top"
                });
            }
        });
    };

    const handleBookmarkClick = (page) => {
        setCurrentPage(page);
        jumpToPage(page - 1)
    };

    return (
        <Menu>
            <MenuButton as={Button}   style={{
                backgroundColor: 'transparent',
                border: '1px white solid',
                borderRadius: '4px',
                color: '#ffffff',
                cursor: 'pointer',
                padding: '8px',
            }} rightIcon={<ChevronDownIcon />}>{isMobile ? <FaList /> : 'Zobrazit záložky'}</MenuButton>
            <MenuList>
                {Object.entries(bookmarks).map(([id, bookmark]) => (

                    <MenuItem key={id}>
                        <Flex justify="space-between" align="center" w="100%">
                            <Box color={"black"} onClick={() => handleBookmarkClick(bookmark.page)}>
                                <Text fontWeight="bold" color={"black"}>Stránka {bookmark.page}</Text>
                                {/*<Text fontSize="sm" color="gray.500">*/}
                                {/*    {bookmark.id_issue.header}*/}
                                {/*</Text>*/}
                            </Box>
                            <IconButton
                                aria-label="Remove bookmark"
                                icon={<DeleteIcon />}
                                size="sm"
                                colorScheme="red"
                                onClick={() => handleRemove(bookmark.id_user_issue_bookmark)}
                            />
                        </Flex>
                    </MenuItem>
                ))}
            </MenuList>
        </Menu>
    );
};